import { Action } from '@ngrx/store';
import { ApplicationQrvey } from '../_models/application-qrvey.model';
import { QueryParamsModel } from '../../_base/crud';

export enum ApplicationQrveyActionTypes {
  ApplicationQrveyPageRequested = '[ApplicationQrvey] ApplicationQrvey Page Requested',
  ApplicationQrveyPageLoaded = '[ApplicationQrvey] ApplicationQrvey Page Loaded',
  ApplicationQrveyPageCancelled = '[ApplicationQrvey] ApplicationQrvey Page Cancelled',
  ApplicationQrveyPageToggleLoading = '[ApplicationQrvey] ApplicationQrvey Page Toggle Loading',
  ApplicationQrveyActionToggleLoading = '[ApplicationQrvey] ApplicationQrvey Action Toggle Loading',
  ThrowApplicationQrveyError = '[ApplicationQrvey] Throw Error',
  FireApplicationQrveySuccess = '[ApplicationQrvey] Fire Success',
}

export class ThrowApplicationQrveyError implements Action {
  readonly type = ApplicationQrveyActionTypes.ThrowApplicationQrveyError;
  constructor(public payload: { error: any }) {}
}

export class FireApplicationQrveySuccess implements Action {
  readonly type = ApplicationQrveyActionTypes.FireApplicationQrveySuccess;
  constructor(public payload: { action_type: string }) {}
}

export class ApplicationQrveyPageRequested implements Action {
  readonly type = ApplicationQrveyActionTypes.ApplicationQrveyPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class ApplicationQrveyPageLoaded implements Action {
  readonly type = ApplicationQrveyActionTypes.ApplicationQrveyPageLoaded;
  constructor(
    public payload: {
      applicationQrveys: ApplicationQrvey[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class ApplicationQrveyPageCancelled implements Action {
  readonly type = ApplicationQrveyActionTypes.ApplicationQrveyPageCancelled;
}

export class ApplicationQrveyPageToggleLoading implements Action {
  readonly type = ApplicationQrveyActionTypes.ApplicationQrveyPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ApplicationQrveyActionToggleLoading implements Action {
  readonly type = ApplicationQrveyActionTypes.ApplicationQrveyActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type ApplicationQrveyActions =
  | ApplicationQrveyPageLoaded
  | ApplicationQrveyPageCancelled
  | ApplicationQrveyPageToggleLoading
  | ApplicationQrveyPageRequested
  | ThrowApplicationQrveyError
  | FireApplicationQrveySuccess
  | ApplicationQrveyActionToggleLoading;
